<template>
  <div>
    <div class="document-container" style="width: 100%; min-width: 100%; margin-bottom: 2rem;">
        <div class="row">
            <div class="col-9">
                <span v-if="document.file.filename.length < 12">{{document.file.filename}}</span>
                <span v-else>{{document.file.filename.substring(0, 12) + '...'}}</span>
            </div>
            <div class="col-2 download-icon" @click="downloadFile(document)">
                <img src="../../assets/icons/download.png" />
            </div>
        </div>
        <div class="row">
            <div class="col document-placeholder mt-5 p-4">
                <img style="max-width: 100%" src="../../assets/icons/document-content.png" />
            </div>
        </div>
        
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import store from '../../store.js';
import 'vue-multi-select/dist/lib/vue-multi-select.css';

export default {
  props: ['document'],
  methods: {
      async downloadFile(data) {
        
        try {
            const res = await store.dispatch('documents/downloadDocument', {
                ApiClient: Vue.prototype.$ApiClient,
                departments: this.$store.getters.getUserData.departments, 
                hash: data.file.hash
            });
            if (res.status === 200) {
                const url = URL.createObjectURL(res.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = data.file.filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        } catch (err) {

      }
    }
  }
}
</script>

<style lang="scss">
    @import "./scss/documents.scss";
</style>
